import React, {useEffect, useMemo} from 'react';

interface HighlightedTextProps {
    children: any & string;
    highlight: string;
}

const HighlightedText = ({children, highlight}: HighlightedTextProps) => {
    const text = children?.toString();
    const idx = text?.toLowerCase()?.indexOf(highlight?.toLowerCase());

    if (idx === -1) {
        return <span>{text}</span>;
    }

    return <>
        {text.slice(0, idx)}
        <b>{text.slice(idx, idx + highlight.length)}</b>
        {text.slice(idx + highlight.length)}
    </>

    // const parts = children.split(new RegExp(`(${highlight})`, 'gi'));
    // return <span>{parts.map((part, i: any) => part.toLowerCase() === highlight.toLowerCase() ? <b key={i}>{part}</b> : part)}</span>;
}

export default HighlightedText;